<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="data?.team?.id ? 'Edit Team' : 'Add Team'"
  [form]="form"
  submitLabel="Save"
  [submitDisabled]="!form.valid || !form.dirty"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
@if (!!data && data.team !== undefined && data.team !== null) {
  <div crucibleDialogContent [formGroup]="form">
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Name</mat-label>
          <input type="text" matInput formControlName="name" placeholder="Name (required)">
            @if (teamNameFormControl.hasError('minlength') && !teamNameFormControl.hasError('required')) {
              <mat-error>
                Must contain {{ MIN_NAME_LENGTH }} or more characters
              </mat-error>
            }
            @if (teamNameFormControl.hasError('required')) {
              <mat-error>
                Name is <strong>required</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="add-margin">
        <div>
          <mat-form-field class="full-width">
            <mat-label>Short Name</mat-label>
            <input type="text" matInput formControlName="shortName" placeholder="Short Name (required)">
              @if (teamShortNameFormControl.hasError('minlength') && !teamShortNameFormControl.hasError('required')) {
                <mat-error>
                  Must contain {{ MIN_NAME_LENGTH }} or more characters
                </mat-error>
              }
              @if (teamShortNameFormControl.hasError('required')) {
                <mat-error>
                  Short Name is <strong>required</strong>
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="add-margin">
          <div>
            <mat-form-field class="full-width">
              <mat-label>Team Type</mat-label>
              <mat-select placeholder="Team Type (required)" formControlName="teamTypeId">
                @for (teamType of data.teamTypeList; track teamType.id) {
                  <mat-option [value]="teamType.id">
                    {{ teamType.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="add-margin">
          <div>
            <mat-checkbox formControlName="hideScoresheet">Hide Scoresheet</mat-checkbox>
          </div>
        </div>
      </div>
    }
</crucible-dialog>
